import React from 'react';

import Media from 'react-responsive';

import { noop } from 'helpers';
import { device } from 'helpers/screenSizes';
import ChevronLeft from 'styles/assets/icons/ChevronLeft';
import { Box } from 'UIKit';
import IconButton from 'UIKit/IconButton';

import classes from './mobileHeader.module.scss';

interface MobileHeaderProps {
  title: string;
  testId: string;
  onBackButtonClick: () => void;
}

const MobileHeader = ({ title, testId, onBackButtonClick }: MobileHeaderProps) => {
  return (
    <Media query={device.down.md}>
      <Box className={classes.mobileHeaderRoot}>
        <IconButton
          onClick={onBackButtonClick}
          className={classes.backButton}
          data-testid={testId}
          icon={<ChevronLeft />}
          onKeyDown={noop}
        />
        {title}
      </Box>
    </Media>
  );
};

export default MobileHeader;
